<template>
  <div class="uk-container">
    <div v-if="$store.getters['account/type'] === 'admin'" class="uk-text-center uk-margin">
      <router-link :to="{ name: 'dentist-create' }" class="uk-button uk-button-primary" data-cy="btn-create">Create Dentist</router-link>
    </div>

    <div class="uk-width-xlarge uk-margin-auto uk-card uk-card-default dt-dentists" data-cy="dentist-list">
      <vue-good-table
        :columns="columns"
        :rows="list"
        :pagination-options="$globals.vgt.pagination"
        style-class="uk-table uk-table-middle uk-table-divider uk-table-hover uk-margin-remove datatable"
        @on-row-click="onRowClick"
      >
        <template slot="table-row" slot-scope="props">
          <template v-if="props.column.field == 'appointments'">
            <aggregated-availability :dentist="props.row.id" />
          </template>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import AggregatedAvailability from '@/components/AggregatedAvailability.vue'

export default {
  name: 'ViewDentistList',

  components: {
    AggregatedAvailability
  },

  data() {
    return {
      columns: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Area',
          field: 'area'
        }
      ]
    }
  },

  computed: {
    userType() {
      return this.$store.getters['account/type']
    },

    list() {
      const source = this.$store.state.dentists.collection
      const rows = []

      source.forEach((dentist) => {
        const status = this.$helpers.status.dentist.find((a) => a.id === dentist.status)

        const data = {
          id: dentist.id,
          name: dentist.name,
          area: this.$helpers.getAreaName(dentist.area),
          status: status ? status.value : 'Error'
        }

        if (this.$store.getters['account/type'] === 'admin') {
          const users = this.$store.getters['users/getByType'](3).filter((user) => user.dentist === dentist.id)
          data.users = `<div uk-tooltip="title: ${users.map((user) => `${user.name.first} ${user.name.last}`).join('<br>')}; pos: right; offset: 20;">${users.length}</div>`
        }

        rows.push(data)
      })

      return rows
    }
  },

  created() {
    if (this.$store.getters['account/type'] === 'operator') {
      this.columns.push({
        label: 'Appointments',
        field: 'appointments',
        sortable: false
      })
    }

    if (this.$store.getters['account/type'] === 'admin') {
      this.columns.push({
        label: 'Status',
        field: 'status',
        sortable: false,
        html: true
      })

      this.columns.push({
        label: 'Users',
        field: 'users',
        sortable: false,
        html: true
      })
    }
  },

  methods: {
    onRowClick(params) {
      if (this.userType === 'admin') {
        this.$router.push({ name: 'dentist-manage', params: { id: params.row.id } })
      }

      if (this.userType === 'operator') {
        this.$router.push({ name: 'dentist-info', params: { id: params.row.id } })
      }
    }
  }
}
</script>

<style lang="scss">
.dt-dentists .vgt-responsive {
  overflow: visible;
}
</style>
